import { Button, Empty, Flex, Select, Spin, Typography } from "antd"
import { useStaffTemplateCategories } from "./useTemplateCategories"
import styles from "./index.css"

type CategoryFieldProps = {
  value: string[]
  onChange: (categories: string[]) => void
}

type CategoryOption = {
  value: string
  label: string
  disabled: boolean
}

export const CategoryField = ({ value, onChange }: CategoryFieldProps) => {
  const { categories, loading, error, reload } = useStaffTemplateCategories()

  return (
    <Flex
      vertical
      gap={8}
    >
      <Select<string[], CategoryOption>
        className={styles.categorySelect}
        aria-label="模板分类"
        mode="multiple"
        allowClear
        placeholder="搜索或选择分类"
        loading={loading}
        showSearch={{
          filterOption: (input, option) =>
            Boolean(option?.value?.includes(input.trim())),
        }}
        options={categories.map((category) => ({
          value: category,
          label: category,
          disabled: Boolean(error),
        }))}
        virtual={false}
        value={value}
        onChange={(selected) => onChange(selected ?? [])}
        notFoundContent={
          loading ? (
            <Spin size="small" />
          ) : (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={error ? "分类加载失败" : "暂无匹配分类"}
            />
          )
        }
      />
      {error && (
        <Flex
          gap={8}
          align="center"
          role="alert"
        >
          <Typography.Text type="danger">{error}</Typography.Text>
          <Button
            size="small"
            disabled={loading}
            onClick={reload}
          >
            重试加载分类
          </Button>
        </Flex>
      )}
    </Flex>
  )
}
